import React from 'react';
import { UnitConverter } from './UnitConverter';

const units = [
  { key: 'lbfeet',    label: 'lb · ft' },
  { key: 'lbinch',    label: 'lb · in' },
  { key: 'kgcm',      label: 'kg · cm' },
  { key: 'kgm',       label: 'kg · m' },
  { key: 'tonmeter',  label: 't · m' },
  { key: 'knewmeter', label: 'kN · m' },
  { key: 'nm',        label: 'N · m' },
];

// Base: lb · ft
const factors = {
  lbfeet:    1,
  lbinch:    12,
  kgcm:      1 / 0.07223,
  kgm:       1 / 7.233,
  tonmeter:  1 / 7233.014,
  knewmeter: 1 / 737.56214927727,
  nm:        1 / 7375621.4927727,
};

export const ConvMoment = () => (
  <UnitConverter
    title="Moment"
    units={units}
    factors={factors}
    explanationTitle="Units of moment"
    explanation="1 lb · ft = 0.138 kg · m. In the English system, 1 lb · foot is approximately 0.138 times 1 kg · metre in the metric system."
  />
);
